export const PortalErrorMessage = (id, messageBundles) => {
  switch (id) {
    case "INVALID_CREDENTIALS":
      return "Las credenciales no son válidas o no tienes permiso para acceder a esta aplicación.";
    case "LIBRARY_UNAVAILABLE":
      return "El entorno MicroStrategy no está disponible o MicroStrategy Library no esta conectado.";
    case "NO_PROJECTS_AVAILABLE":
      return "No tienes acceso a ningun proyecto dentro de este entorno. ";
    case "ERROR_RETRIVING_PAGE":
      return "Se ha producido un error al recuperar la información de esta página.";
    case "ERROR_INSTANCE_CREATION":
      return "No se ha podido crear la instancia del dashboard. ";
    case "TIMEOUT":
      return "Se ha perdido la sesión.";
    case "EMBEDDING_DOSSIER_ERROR":
      return "Se ha producido un error al intentar embeber este dashboard.";
    case "PRIVILEGIOS":
      return "No tienes lo privilegios necesarios para realizar esta acción. Contacta con tu administrador.";
    default:
      return "Error en la aplicación. ";
  }
};

export function GenericPortalError(id, severity, action) {
  let error = new Error();

  if (action?.mstrRestAPIErrorResponse?.code === "ERR014") {
    error.id = "PRIVILEGIOS";
    error.severity = "warning"; //warning error success
  } else {
    error.id = id;
    error.severity = severity; //warning error success
  }
  error.message = PortalErrorMessage(error.id);
  error.action = action; //Error de la API.

  return error;
}
